export default __webpack_public_path__ + "static/swirlpendantandring-77aa407dc9228de8f6df558a5eb8913a.png";